export default "__VITE_ASSET__DcvKv9lq__"